<template>
    <footer class="main-footer" style="background-image:url('/images/heartpattern.png')">
        <div class="site-width">
            <div class="flex flex-wrap">
                <div class="left-col">
                    <h3 class="lilita weight-bold">Contact:</h3><br />
                    <p>Phone: <a href="tel:6126233363">(612) 623-3363</a> <br>
                        Fax: (612) 331-9401<br>
                        Email: <a href="mailto:info@meals-on-wheels.com" title="Email Metro Meals on Wheels">info@meals-on-wheels.com</a>
                    </p>
                    <p>1200 Washington Avenue S.,<br> Suite 380, Minneapolis, MN 55415</p>
                    <img style="width:270px;" class="max-image footer-meals-image" src="/images/2022_Horiz_WEB.png" alt="meals on wheels america 2022-member" />
                </div>
                <div class="right-col">
                    <h3 class="lilita weight-bold">Connect:</h3>
                    <ul class="social-menu">
                        <li class="social-menu_item" style="width: 50px;"><a class="social-menu_item_link" target="_blank" href="https://www.facebook.com/MetroMealsOnWheels?ref=profile" title="Metro Meals on Wheels on Facebook"><svg id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m512 256c0-141.4-114.6-256-256-256s-256 114.6-256 256 114.6 256 256 256c1.5 0 3 0 4.5-.1v-199.2h-55v-64.1h55v-47.2c0-54.7 33.4-84.5 82.2-84.5 23.4 0 43.5 1.7 49.3 2.5v57.2h-33.6c-26.5 0-31.7 12.6-31.7 31.1v40.8h63.5l-8.3 64.1h-55.2v189.5c107-30.7 185.3-129.2 185.3-246.1z"></path></svg></a></li>
                        <li class="social-menu_item" style="width: 58px;"><a class="social-menu_item_link" target="_blank" href="https://twitter.com/Meals_on_Wheels" title="Metro Meals on Wheels on Twitter"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm116.886719 199.601562c.113281 2.519532.167969 5.050782.167969 7.59375 0 77.644532-59.101563 167.179688-167.183594 167.183594h.003906-.003906c-33.183594 0-64.0625-9.726562-90.066406-26.394531 4.597656.542969 9.277343.8125 14.015624.8125 27.53125 0 52.867188-9.390625 72.980469-25.152344-25.722656-.476562-47.410156-17.464843-54.894531-40.8125 3.582031.6875 7.265625 1.0625 11.042969 1.0625 5.363281 0 10.558593-.722656 15.496093-2.070312-26.886718-5.382813-47.140624-29.144531-47.140624-57.597657 0-.265624 0-.503906.007812-.75 7.917969 4.402344 16.972656 7.050782 26.613281 7.347657-15.777343-10.527344-26.148437-28.523438-26.148437-48.910157 0-10.765624 2.910156-20.851562 7.957031-29.535156 28.976563 35.554688 72.28125 58.9375 121.117187 61.394532-1.007812-4.304688-1.527343-8.789063-1.527343-13.398438 0-32.4375 26.316406-58.753906 58.765625-58.753906 16.902344 0 32.167968 7.144531 42.890625 18.566406 13.386719-2.640625 25.957031-7.53125 37.3125-14.261719-4.394531 13.714844-13.707031 25.222657-25.839844 32.5 11.886719-1.421875 23.214844-4.574219 33.742187-9.253906-7.863281 11.785156-17.835937 22.136719-29.308593 30.429687zm0 0"></path></svg></a></li>
                        <li class="social-menu_item" style="width: 58px;"><a class="social-menu_item_link" target="_blank" href="https://www.instagram.com/mealsonwheelsmn/" title="Metro Meals on Wheels on Instagram"><svg id="Capa_1" enable-background="new 0 0 49.652 49.652" viewBox="0 0 49.652 49.652" xmlns="http://www.w3.org/2000/svg"><g><g><g><path d="m24.825 29.796c2.739 0 4.972-2.229 4.972-4.97 0-1.082-.354-2.081-.94-2.897-.903-1.252-2.371-2.073-4.029-2.073-1.659 0-3.126.82-4.031 2.072-.588.816-.939 1.815-.94 2.897-.003 2.741 2.228 4.971 4.968 4.971z"></path><path d="m35.678 18.746v-4.166-.62l-.623.002-4.164.013.016 4.787z"></path><path d="m24.826 0c-13.689 0-24.826 11.137-24.826 24.826 0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826 0-13.689-11.136-24.826-24.826-24.826zm14.119 21.929v11.56c0 3.011-2.448 5.458-5.457 5.458h-17.324c-3.01 0-5.457-2.447-5.457-5.458v-11.56-5.764c0-3.01 2.447-5.457 5.457-5.457h17.323c3.01 0 5.458 2.447 5.458 5.457z"></path><path d="m32.549 24.826c0 4.257-3.464 7.723-7.723 7.723s-7.722-3.466-7.722-7.723c0-1.024.204-2.003.568-2.897h-4.215v11.56c0 1.494 1.213 2.704 2.706 2.704h17.323c1.491 0 2.706-1.21 2.706-2.704v-11.56h-4.217c.367.894.574 1.873.574 2.897z"></path></g></g></g></svg></a></li>
                        <li class="social-menu_item" style="width: 58px;"><a class="social-menu_item_link" target="_blank" href="https://www.youtube.com/user/MetroMealsonWheels" title="Metrol Meals on Wheels on YouTube"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m224.113281 303.960938 83.273438-47.960938-83.273438-47.960938zm0 0"></path><path d="m256 0c-141.363281 0-256 114.636719-256 256s114.636719 256 256 256 256-114.636719 256-256-114.636719-256-256-256zm159.960938 256.261719s0 51.917969-6.585938 76.953125c-3.691406 13.703125-14.496094 24.507812-28.199219 28.195312-25.035156 6.589844-125.175781 6.589844-125.175781 6.589844s-99.878906 0-125.175781-6.851562c-13.703125-3.6875-24.507813-14.496094-28.199219-28.199219-6.589844-24.769531-6.589844-76.949219-6.589844-76.949219s0-51.914062 6.589844-76.949219c3.6875-13.703125 14.757812-24.773437 28.199219-28.460937 25.035156-6.589844 125.175781-6.589844 125.175781-6.589844s100.140625 0 125.175781 6.851562c13.703125 3.6875 24.507813 14.496094 28.199219 28.199219 6.851562 25.035157 6.585938 77.210938 6.585938 77.210938zm0 0"></path></svg></a></li>
                        <li class="social-menu_item" style="width: 58px;"><a class="social-menu_item_link" target="_blank" href="https://visitor.r20.constantcontact.com/d.jsp?llr=5hgut7n6&amp;p=oi&amp;m=1011351165182&amp;sit=k5glmt74&amp;f=7cf14270-53d9-4e8b-9ce6-590e0655c6f8" title="Subscribe to the Metro Meals on Wheels Newsletter"><svg id="Layer_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m256 512c-141.159 0-256-114.841-256-256s114.841-256 256-256 256 114.841 256 256-114.841 256-256 256zm132.758-166.069c3.156 0 5.725-2.568 5.725-5.725v-160.717l-130.25 103.432c-2.41 1.915-5.323 2.872-8.234 2.872s-5.823-.958-8.234-2.872l-130.249-103.432v160.717c0 3.157 2.569 5.725 5.725 5.725zm-19.96-179.862-112.798 89.575-112.799-89.575zm52.168 5.725v168.414c0 17.759-14.449 32.208-32.208 32.208h-265.517c-17.76 0-32.207-14.449-32.207-32.208v-168.414c0-17.759 14.448-32.207 32.207-32.207h265.517c17.759-.001 32.208 14.448 32.208 32.207z" fill-rule="evenodd"></path></svg>
                    </a></li></ul><a class="social-menu_item_link" target="_blank" href="https://visitor.r20.constantcontact.com/d.jsp?llr=5hgut7n6&amp;p=oi&amp;m=1011351165182&amp;sit=k5glmt74&amp;f=7cf14270-53d9-4e8b-9ce6-590e0655c6f8" title="Subscribe to the Metro Meals on Wheels Newsletter">

                    </a>
                    <p><a class="social-menu_item_link" target="_blank" href="https://visitor.r20.constantcontact.com/d.jsp?llr=5hgut7n6&amp;p=oi&amp;m=1011351165182&amp;sit=k5glmt74&amp;f=7cf14270-53d9-4e8b-9ce6-590e0655c6f8" title="Subscribe to the Metro Meals on Wheels Newsletter">
                      </a><a href="https://meals-on-wheels.com/privacy-policy/" title="Privacy Policy">Website Privacy Policy</a> | <a href="https://meals-on-wheels.com/donate/donor-privacy-and-security-policy/" title="Donor Privacy and Security Policy">Donor Privacy and Security Policy</a> | <a href="https://meals-on-wheels.com/site-map" title="Site Map">Site Map</a>
                    </p>

                    <p>&copy; Copyright 2022 Metro Meals on Wheels. <span class="break-mobile">All Rights Reserved.</span></p>

                    <p><small>Site by <a href="https://brandography.com">Brandography</a></small></p>

                </div>
            </div>
        </div>

        <a class="back-to-top" href="#">
            <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
        </a>
    </footer>
</template>

<script>
export default {
  name: "Footer",
  components: {},
  data: () => ({}),
  created: function() {},
  methods: {}
};
</script>

<style>
/* FOOTER */
@import url('https://fonts.googleapis.com/css2?family=Passion+One:wght@700&display=swap');
body footer.main-footer {
  background-color: #f5aa01;
  color: #666;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
  box-sizing: border-box;
}
body footer.main-footer a, body footer.main-footer a:visited, body footer.main-footer a:hover, body footer.main-footer a:active {
  color: currentColor;
  text-decoration: none;
}
body footer.main-footer h3, body footer.main-footer p {
  color: white;
}
body footer.main-footer h3 {
  font-family: 'Passion One', cursive;
  font-size: 20px;
}
body footer.main-footer .left-col {
  width: 50%;
  padding-left: 200px;
  line-height: 1.4;
  box-sizing: border-box;
  padding-right: 40px;
}
body footer.main-footer .right-col {
  width: 50%;
  box-sizing: border-box;
}
body footer.main-footer .footer-sidebar {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  padding: 0;
  list-style-type: none;
  align-items: stretch;
  flex-flow: row wrap;
  font-size: 1.25em;
}
body footer.main-footer .footer-sidebar .widgettitle {
  margin: 0;
}
body footer.main-footer .footer-sidebar .widget:only-child {
  flex: 0 0 100%;
}
body footer.main-footer .footer-sidebar .widget:nth-last-child(n+2) {
  flex: 0 0 50%;
}
body footer.main-footer .footer-sidebar .widget:nth-last-child(n+3), body footer.main-footer .footer-sidebar .widget:nth-last-child(n+3) ~ .widget {
  flex: 0 0 33.333%;
}
body footer.main-footer .footer-sidebar .widget:nth-child(n+4) {
  margin-top: 1em;
}
@media (max-width: 1300px) {
  body footer.main-footer .site-width {
    padding-left: 20px;
    padding-right: 20px;
 }
  body footer.main-footer .left-col {
    width: 40%;
    padding-left: 0;
 }
  body footer.main-footer .right-col {
    width: 60%;
 }
}
@media (max-width: 1024px) {
  body footer.main-footer .right-col {
    padding-left: 20px;
 }
}
@media (max-width: 767px) {
  body footer.main-footer {
    text-align: center;
 }
  body footer.main-footer .left-col {
    width: 100%;
    padding-right: 0;
 }
  body footer.main-footer .right-col {
    width: 100%;
    padding-left: 0;
 }
 .footer-meals-image {
   margin: 0px auto;
 }
}

/* END FOOTER */

/* SOCIAL MENU */
.social-menu {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  text-align: center;
  display: flex;
}

.social-menu_item {
  display: inline-block;
  padding: 0 0.5em;
  width: 50px;
}
.social-menu_item a {
  display: block;
}

li.social-menu_item:first-of-type {
  padding-left: 0;
}

.social-menu_item_icon {
  max-width: 100%;
}

.social-menu svg {
  max-width: 100%;
  fill: white;
}

@media screen and (max-width: 900px) {
  .social-menu {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0 auto;
  }
}

ul.social-menu {
    padding-left:0px;
    margin-top:14px;
    margin-bottom: 14px;
}
/* END SOCIAL MENU */

/* SITE WIDTH */
.site-width {
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 1240px) {
  .site-width {
    padding-left: 20px;
    padding-right: 20px;
  }
}
@media (max-width: 1300px) {
  footer.main-footer .site-width {
    padding-left: 20px;
    padding-right: 20px;
  }
  footer.main-footer .left-col {
    width: 40%;
    padding-left: 0;
  }
  footer.main-footer .right-col {
    width: 60%;
  }
}
@media (max-width: 1024px) {
  footer.main-footer .right-col {
    padding-left: 20px;
  }
}
@media (max-width: 767px) {
  footer.main-footer {
    text-align: center;
  }
  footer.main-footer .left-col {
    width: 100%;
    padding-right: 0;
  }
  footer.main-footer .right-col {
    width: 100%;
    padding-left: 0;
  }
}
/* END SITE WIDTH */
</style>
